class CampaignPopup extends HTMLElement {
  connectedCallback() {
    // <modal-dialog> relocates itself to a direct child of <body> as soon as
    // global.js defines the custom element, which happens before this
    // element's own connectedCallback runs — so it can no longer be found as
    // a descendant here and must be looked up by id instead.
    const modal = document.getElementById(`CampaignPopup-${this.dataset.popupId}`);
    if (!modal) return;

    const storageKey = `campaign-popup-shown-${this.dataset.popupId}`;
    const delayMs = (parseFloat(this.dataset.delay) || 0) * 1000;

    // Once per visit: sessionStorage is emptied when the tab closes, so
    // browsing on to other pages during this visit won't show it again, but a
    // visitor who comes back later sees it once more.
    try {
      if (sessionStorage.getItem(storageKey)) return;
    } catch (error) {
      return;
    }

    setTimeout(() => {
      modal.show();
      try {
        sessionStorage.setItem(storageKey, '1');
      } catch (error) {
        // Ignore storage errors (e.g. private browsing).
      }
    }, delayMs);
  }
}

customElements.define('campaign-popup', CampaignPopup);
